var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.transferState,
            center: "",
            title: _vm.$t("m.rejection_reason"),
            "close-on-click-modal": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.transferState = $event
            }
          }
        },
        [
          _c("el-input", {
            staticClass: "textinput",
            attrs: {
              type: "textarea",
              resize: "none",
              placeholder: _vm.$t("m.reasons-for-refusal")
            },
            model: {
              value: _vm.rejectReason,
              callback: function($$v) {
                _vm.rejectReason = $$v
              },
              expression: "rejectReason"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.transferState = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.transferEdit }
                },
                [_vm._v(_vm._s(_vm.$t("m.Confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36ee3c5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ee3c5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/anchor/dialogs/transferAuditDialog.vue
// module id = null
// module chunks = 